// extracted by mini-css-extract-plugin
export default {"menuItem":"UserItem_menuItem__lin5F","menuItemText":"UserItem_menuItemText__5jLX0","menuItemTextActive":"UserItem_menuItemTextActive__4SjtK","user":"UserItem_user__b-Am+"};